import ChangeContactInformation from "../views/tasks/change-contact-information";
import CrossDataCheck from "../views/tasks/cross-data-check";
import HandleRejection from "../views/tasks/handle-rejection";
import ManualAccountNumberReview from "../views/tasks/manual-account-number-review";
import ManualCheckBgc from "../views/tasks/manual-check-bgc";
import ManualCheckFinal from "../views/tasks/manual-check-final";
import ManualIdReview from "../views/tasks/manual-id-review";
import ManualInsuranceSale from "../views/tasks/manual-insurance-sale";
import ManualApplicationReview from "../views/tasks/manual-payout-approval";
import ManualPepReview from "../views/tasks/manual-pep-review";
import ManualRefundReview from "../views/tasks/manual-refund-review";
import ManualTinkConsentReview from "../views/tasks/manual-tink-consent-review";
import ManualVideoIdFollowUp from "../views/tasks/manual-video-id-follow-up";
import NoReply from "../views/tasks/no-reply";
import AppWrapper from "../views/tasks/poa-and-refinance-documentation";
import { withTaskPermissions } from "../views/tasks/TaskPermissionsContext";
import ChangeApplication from "../views/tasks/trigger-change-application";
import ChangeLoanAmount from "../views/tasks/trigger-change-loan-amount";
import ContactApplicant from "../views/tasks/trigger-communication-process";
import UpdateApplication from "../views/tasks/update-application";
import UpdateRefinanceTask from "../views/tasks/update-refinance";
import UploadDocument from "../views/tasks/upload-document";
import VerifyRefinance from "../views/tasks/verify-refinance";

export const tasks = {
  taskLists: [
    {
      id: "task-list-failed-tasks",
      title: "task-list-title-failed-tasks",
      query: "status=failed"
    },
    {
      id: "task-list-pending-user-tasks",
      title: "task-list-title-pending-user-tasks",
      query: "taskCategory=user-task&status=pending"
    },
    {
      id: "task-list-pending-message-tasks",
      title: "task-list-title-pending-message-tasks",
      query:
        "taskCategory=message-task&status=pending&taskType=!credit-evaluate-application"
    }
  ],
  // Every task view gets the actions flow-process allows on its task, so the shared task
  // buttons are disabled when the user may not use them
  taskComponents: {
    "manual-pep-review": {
      titleMap: () => "Manual AML / PEP Review",
      component: withTaskPermissions(ManualPepReview),
      size: "small",
      customWidth: "90%",
      customHeight: "90%"
    },
    "manual-refund-review": {
      titleMap: () => "Manual Refund Review",
      component: withTaskPermissions(ManualRefundReview),
      size: "small",
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "manual-payout-approval": {
      titleMap: () => "Manual Payout Approval",
      component: withTaskPermissions(ManualApplicationReview),
      size: "small",
      customWidth: "90%",
      customHeight: "90%"
    },
    "manual-id-review": {
      titleMap: () => "Manual ID Review",
      component: withTaskPermissions(ManualIdReview),
      size: "small",
      customWidth: "90%",
      customHeight: "90%"
    },
    "cross-data-check": {
      titleMap: () => "Cross Data Check",
      component: withTaskPermissions(CrossDataCheck),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "verify-refinance-documentation": {
      titleMap: () => "Verify refinancing details",
      component: withTaskPermissions(AppWrapper),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "update-refinance": {
      titleMap: () => "Update refinance",
      component: withTaskPermissions(UpdateRefinanceTask),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "verify-refinance": {
      titleMap: () => "Verify refinance",
      component: withTaskPermissions(VerifyRefinance),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "manual-check-final": {
      titleMap: () => "Final check before disbursement",
      size: "small",
      component: withTaskPermissions(ManualCheckFinal),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "manual-bgc-handling": {
      titleMap: () => "Manual Bank Giro Check",
      component: withTaskPermissions(ManualCheckBgc),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "manual-insurance-sale": {
      titleMap: () => "Manual Insurance Sale",
      component: withTaskPermissions(ManualInsuranceSale),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "application-updated": {
      disabled: true
    },
    // Make this invisible in the UI
    "follow-up-toggle": {
      disabled: true
    },
    "trigger-communication-process": {
      titleMap: () => "Contact applicant",
      component: withTaskPermissions(ContactApplicant)
    },
    "contact-applicant": {
      titleMap: () => "Contact applicant",
      component: withTaskPermissions(ContactApplicant)
    },
    "trigger-change-application": {
      titleMap: () => "Change application",
      component: withTaskPermissions(ChangeApplication)
    },
    "change-contact-information": {
      titleMap: () => "Change contact information",
      component: withTaskPermissions(ChangeContactInformation),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "trigger-change-loan-amount": {
      titleMap: () => "Change loan amount",
      component: withTaskPermissions(ChangeLoanAmount)
    },
    "update-application": {
      titleMap: () => "Update application",
      component: withTaskPermissions(UpdateApplication),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "handle-rejection": {
      titleMap: () => "Handle rejection",
      component: withTaskPermissions(HandleRejection),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    // Make this invisible in the UI
    "credit-evaluate-application": {
      disabled: true
    },
    "manual-video-id-follow-up": {
      titleMap: () => "Video ID Follow Up",
      component: withTaskPermissions(ManualVideoIdFollowUp),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "no-reply": {
      titleMap: () => "No Reply",
      component: withTaskPermissions(NoReply),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "manual-account-number-review": {
      titleMap: () => "Manual Account Number Review",
      component: withTaskPermissions(ManualAccountNumberReview),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "manual-tink-consent-review": {
      titleMap: () => "Manual Tink Consent Review",
      component: withTaskPermissions(ManualTinkConsentReview),
      customWidth: "max-content",
      customHeight: "max-content"
    },
    "upload-document": {
      titleMap: () => "Upload document",
      component: withTaskPermissions(UploadDocument),
      customWidth: "max-content",
      customHeight: "max-content"
    }
  }
};
